export const dollarFormatter = (dollarAmount: number) => {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(dollarAmount);
};

export const percentageFormatter = (percentageDecimal: number) => {
  return percentageDecimal.toLocaleString(undefined, {
    style: 'percent',
    minimumFractionDigits: 2,
  });
  // return (percentageDecimal * 100.0).toFixed(2) + '%';
};
